import { createBrowserHistory } from 'history'
import type { History } from 'history'

export const history = createBrowserHistory() as History
if (sessionStorage.__DEBUG_ON_HISTORY) {
  const push = history.push.bind(history)
  history.push = (...args) => {
    console.warn('history.push', ...args)
    return push(...args)
  }
  const replace = history.replace.bind(history)
  history.replace = (...args) => {
    console.warn('history.replace', ...args)
    return replace(...args)
  }
}

export default history
